export const TRANSACTION_STATES = {
  pending: "Pendiente",
  completed: "Completada",
  approved: "Aprovada",
  cancelled: "Cancelada",
};

export enum TransactionStates {
  pending = "Pendiente",
  completed = "Completada",
  approved = "Aprovada",
  cancelled = "Cancelada",
}
